import { InvoiceItem } from "@/api/opb/opbTypes";
import i18n from "@/i18n";
import { createColumnHelper } from "@tanstack/react-table";
import { formatCurrency } from "@/utils/string";
import { formatDateFromYYYYMMDD, getDateFnsLocale } from "@/utils/date";
import { Locale } from "@/i18n/types";

const columnHelper = createColumnHelper<InvoiceItem>();

export const getColumns = ({ currencyCode }: { currencyCode: string }) => [
  columnHelper.accessor("chargeName", {
    cell: (props) => <div className="pb-3 lg:p-0">{props.getValue()}</div>,
    header: () => i18n.t("Item", { ns: "invoice" }),
  }),
  columnHelper.accessor("chargeDescription", {
    id: "chargeDescription",
    cell: (props) => <span className="text-left">{props.getValue()}</span>,
    header: () => i18n.t("Description", { ns: "invoice" }),
  }),
  columnHelper.accessor("serviceStartDate", {
    id: "servicePeriod",
    header: () => i18n.t("Service Period", { ns: "invoice" }),
    cell: (props) => {
      const { serviceEndDate, serviceStartDate } = props.row.original;

      const start = serviceStartDate
        ? formatDateFromYYYYMMDD(serviceStartDate, "P", {
            locale: getDateFnsLocale(i18n.language as Locale),
          })
        : "";
      const end = serviceEndDate
        ? formatDateFromYYYYMMDD(serviceEndDate, "P", {
            locale: getDateFnsLocale(i18n.language as Locale),
          })
        : "";

      return (
        <span>
          {start} - {end}
        </span>
      );
    },
  }),
  columnHelper.accessor("unitPrice", {
    header: () => (
      <div className="text-right">
        {i18n.t("Unit Price", { ns: "invoice" })}
      </div>
    ),
    cell: (props) => (
      <div className="pb-3 lg:text-right lg:p-0">
        <span className="lg:hidden">{props.row.original.quantity} * </span>
        {props.row.original.processingType === "Discount" &&
        props.row.original.description !== "Promotional Discount"
          ? `${props.getValue()}%`
          : formatCurrency({
              value: props.getValue(),
              currency: currencyCode,
              lang: i18n.language,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
      </div>
    ),
  }),
  columnHelper.accessor("quantity", {
    header: () => (
      <div className="text-right">{i18n.t("Quantity", { ns: "invoice" })}</div>
    ),
    cell: (props) => <div className="text-right">{props.renderValue()}</div>,
  }),
  columnHelper.accessor("chargeAmount", {
    header: () => (
      <div className="text-right">{i18n.t("Amount", { ns: "invoice" })}</div>
    ),
    cell: (props) => (
      <div className="pb-3 lg:text-right lg:p-0">
        <span className="lg:hidden">{props.row.original.quantity} * </span>
        {formatCurrency({
          value: props.getValue(),
          currency: currencyCode,
          lang: i18n.language,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </div>
    ),
  }),
];
